import NoticeLegale from './NoticeLegale';
import ErrorBoundary from 'utils/ErrorBoundary';
import ErrorAlert from 'components/AlertMessage/ErrorAlert';

const Index = () => (<ErrorBoundary fallback={<ErrorAlert>La Notice L�gale n'a pas �t� en mesure de charger</ErrorAlert>}>
    <NoticeLegale/>
</ErrorBoundary>);

export default Index; 